import { Component, OnInit } from '@angular/core';
import {User} from '../models/User';
import {StateService} from '../state.service';
import {State} from 'ngx-chips/core/providers/drag-provider';
import {Router} from '@angular/router';
import {AppService} from '../app.service';

@Component({
  selector: 'app-professional-list',
  templateUrl: './professional-list.component.html',
  styleUrls: ['./professional-list.component.css']
})
export class ProfessionalListComponent implements OnInit {

  public accessCode: string;
  public accessUser: User;
  public searched: boolean = false;

  constructor(private stateService: StateService, private router: Router, private appService: AppService) {
    this.appService.pageTitle = 'Otentica - Professionals';
  }

  ngOnInit(): void {
  }

  public searchByAccessCode(): void {
    this.searched = true;
    this.accessUser = this.stateService.getUserByAccessCode(this.accessCode);
    console.log('a', this.stateService.getUserByAccessCode);
    console.log('b', this.stateService.getAllUsers);
  }

  public getProfessionals(): User[] {
    return this.stateService.getAllUsers();
  }

  public canView(): (user: User) => boolean {
    let stateService: StateService = this.stateService;
    return (user: User) => {
      let currentUsername: string = stateService.getUsername();
      return user.pendingAccess.indexOf(currentUsername) > -1
        || user.activeAccess.indexOf(currentUsername) > -1;
    }
  }

  public accessRequested(user: User): boolean {
    return user.pendingAccess.indexOf(this.stateService.getUsername()) > -1;
  }

  public accessGranted(user: User): boolean {
    return user.activeAccess.indexOf(this.stateService.getUsername()) > -1;
  }

  public requestAccess(user: User): void {
    user.pendingAccess.push(this.stateService.getUsername());
  }

  public gotoProfessional(userId: string): void {
    this.router.navigate(['certificates', userId]);
  }

}
